import { Component, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { AccountService } from '../shared/account.service';
import { BlobStorageService } from '../../shared/blob-storage.service';

import { AccountWizardFormComponent } from './account-wizard-form/account-wizard-form.component';
import { FileInputComponent } from '../../shared/file-input/file-input.component';
import { LoadingDialogComponent } from '../../shared/modals/loading/loading-dialog.component';
import { forkJoin } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-account-wizard',
  templateUrl: './account-wizard.component.html',
  styleUrls: ['./account-wizard.component.scss']
})
export class AccountWizardComponent {

  additionalImages = Array(3);
  receipt?: File;

  @ViewChild('stepper', { static: true }) stepper?: MatStepper;
  @ViewChild('accountForm', { static: true }) accountForm?: AccountWizardFormComponent;

  @ViewChildren(FileInputComponent) fileInputs?: QueryList<FileInputComponent>;

  constructor(
    private _accountService: AccountService,
    private _blobStorageService: BlobStorageService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
  ) { }

  onClickNextButton() {
    this.receipt = this.fileInputs?.toArray()[0].value ?? undefined;
    this.stepper?.next();
  }

  onClickCreateButton() {
    const dialog = this.openLoadingDialog();
    forkJoin(this.fileInputs?.map(i => i.value)
      .filter(i => i)
      .map(i => this._blobStorageService.putReceipt(null, i as File))
    ).pipe(
      mergeMap((res) => {
        const account = this.accountForm?.getAccount();
        if (!account) {
          throw (new Error('入力内容を取得できませんでした。'));
        }
        account.images = res;
        return this._accountService.createAccount(account);
      })
    ).subscribe({
      next: () => {
        this.stepper?.next();
      },
      error: (e) => {
        console.error(e);
        this._snackBar.open('エラーが発生しました。', undefined, { duration: 2000 });
      },
      complete: () => {
        dialog.close();
      }
    });
  }

  onClickResetButton() {
    this.fileInputs?.forEach(i => i.value = null);
    this.stepper?.reset();
  }

  openLoadingDialog() {
    return this.dialog.open(LoadingDialogComponent, {
      maxWidth: '100vw',
      width: '100%',
      height: '100vh',
      panelClass: 'app-dialog'
    });
  }
}
